import { useSelector } from "react-redux";
import _ from "lodash";

export default function useSession() {
  const session = useSelector((state) => state.session);
  const customerId = _.get(session, "user.customerId");
  const customerType = _.get(session, "user.customerType");

  return {
    authenticated: session.authenticated,
    accessToken: session.user.accessToken,
    user: session.user,
    customerId,
    customerType,
    isSwitched:
      _.get(session, "user.OrgId", "na") !==
      _.get(session, "user.initialUser.OrgId", "na"),
  };
}
